import { Errors } from '@app/types/global';

import { CMSAPIResponseBody } from './interfaces';

/**
    If the error response from CMS API includes an error regarding
    one of the specific fields, make it visible for the 
    appropriate field.
    TODO how do we make this mulitilingual? Implement some sort of code?
*/
export function getFieldSpecificErrors(fields: string[], response: CMSAPIResponseBody) {
  let fieldSpecificErrorFound = false;
  let fieldSpecificErrors: Errors = {};
  response.errors!.forEach((errorString: string) => {
    const errorStringAsLowerCase = errorString.toLowerCase();
    fields.forEach((field) => {
      if (errorStringAsLowerCase.includes(field)) {
        fieldSpecificErrorFound = true;
        fieldSpecificErrors[field] = errorString + '\n';
      }
    });
  });
  return {
    fieldSpecificErrorFound,
    fieldSpecificErrors,
  };
}
